/**
 * This function will create a QR link with client ID and session ID embedded.
 * @param clientId
 * @returns Promise<string>
 */
export async function createSessionQRLink(clientId: string) {
  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get('sessionId');
  const isMalchus = clientId === '715053';
  const isNeems = clientId === '553777';
  const isSisley = clientId === '417017';
  if (isMalchus) {
    return `https://malchus.truetoform.fit/send-avatar?clientId=${clientId}&sessionId=${sessionId}`;
  }

  if (isNeems) {
    return `https://neems.truetoform.fit/send-avatar?clientId=${clientId}&sessionId=${sessionId}`;
  }

  if (isSisley) {
    return `https://sisley.truetoform.fit/send-avatar?clientId=${clientId}&sessionId=${sessionId}`;
  }

  const pwaLink = `${process.env.REACT_APP_PWA_URL}/send-avatar?clientId=${clientId}&sessionId=${sessionId}`;
  return pwaLink;
}
